<template>
  <div id="topSales" ref="topSales"></div>
</template>
<script>
import echarts from 'echarts'
import moment from 'moment'
export default {
    props: ['topData'],
    data () {
        return {
            data: [],
            legendData: []
        }
    },
    watch: {
        topData () {
            // this.draw()
            if (!this.topData.payload || this.topData.payload.length === 0) {
                this.$refs.topSales.style.display = 'none'
            } else {
                this.$refs.topSales.style.display = 'block'
                this.handleTotalData(this.topData)
            }
            return this.topData
        }
    },
    mounted () {
        // console.log(this.topData)
    },
    methods: {
        draw () {
            let myChart = echarts.init(this.$refs.topSales)
            myChart.setOption({
                legend: {
                    //  orient: 'vertical',
                    data: this.legendData
                    //   selectedMode: false,
                    //   formatter: (l, o)=>{
                    //          console.log(l, o)
                    //   }
                }, // 图例文字颜色
                grid: {
                    x: 60,
                    y: 30,
                    x2: 30,
                    y2: 30,
                    borderWidth: 1,
                    borderColor: '#dedede'
                },
                tooltip: {
                    trigger: 'axis',
                    // 提示框背景色
                    backgroundColor: '#FFFFFF',
                    // 提示框的边框
                    borderWidth: 1,
                    // 提示框的边框色
                    borderColor: '#d6d6d6',
                    // 提示框 内边距
                    padding: [3, 5],
                    textStyle: {
                        align: 'left',
                        // 提示框颜色
                        color: '#333333',
                        fontFamily: 'NotoSansCJKtc',
                        fontSize: 12
                        // color:'rgba(0, 224, 218, 0.3)'
                    },
                    formatter: (param, ticket, callback) => {
                        // 用定时器模拟异步事件
                        // console.log(param)
                        // let that = this;
                        setTimeout(function () {
                            let res

                            let str = ''
                            param.forEach((e, i) => {
                                str += `
                <p style="padding:0px;margin:0px;">
                ${e.marker}
                ${e.seriesName}:
                <span style="padding:0px;margin:0px;">${e.value[1]}</span>
                </p>
              `
                                if (i === param.length - 1) {
                                    let itemP = `
                <p style="padding:0px;margin:0px;">${moment(
        param[0].name
    ).format('YYYY年MM月DD日')}</p>`
                                    res = itemP + str
                                    callback(ticket, res)
                                }
                            })
                        }, 500)
                        return 'loading' // 内容还没返回时显示的内容
                    }
                },
                xAxis: {
                    type: 'time',
                    axisLabel: {
                        show: true,
                        textStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)"
                            // x轴字体颜色
                            color: '#333333',
                            fontSize: 12,
                            fontFamily: 'NotoSansCJKtc',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            letterSpacing: 0.8
                        },
                        formatter: function (value, index) {
                            var date = new Date(value)
                            var texts = [date.getMonth() + 1, date.getDate()]
                            //   texts.unshift(date.getFullYear());
                            return texts.join('/')
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#333333',
                            width: 1
                        }
                    },
                    splitLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    //   max: this.Max,
                    //   interval: Math.ceil(this.Max / 5),
                    splitLine: {
                        show: true,
                        lineStyle: { type: 'dashed' }
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 12,
                        fontFamily: 'NotoSansCJKtc',
                        fontWeight: 300,
                        fontStyle: 'normal',
                        letterSpacing: 0.7,
                        color: 'rgba(51, 51, 51, 0.5)'
                    }
                },
                series: this.data
            })
        },
        handleTotalData (topData) {
            // 种类
            this.legendData = topData.payload.map((item, index) => {
                return item.projectName.substring(0, 3) + index
            })
            this.data = this.legendData.map((element, i) => {
                return {
                    name: this.legendData[i],
                    type: 'line',
                    symbol: 'circle',
                    symbolSize: p => {
                        if (parseFloat(p[1]) > 0) {
                            return 4
                        } else {
                            return 0
                        }
                    },
                    //   stack: `总量${i}`,
                    data: topData.payload[i].list.map((item, index) => {
                        return {
                            name: item.day,
                            value: [item.day, item.sum]
                        }
                    })
                }
            })
            this.draw()
        }
    }
}
</script>
<style scoped>
#topSales {
    width: 100%;
    height: 219px;
    font-size: 12px;
}
</style>
